export default {
	VALIDATION_ERROR: 4001,
	PARSING_ERROR: 4002,

	INTERNAL_ERROR: 5001,
	AGENT_ALREADY_DEPLOYED_ERROR: 5002
}
